<template>
  <div class="route-wrapper">
    <div class="spotlight-card">
      <SuccessAcceptInvite v-if="currentState.startsWith('success-')" v-on:goToApollo="onGoToApollo">
        <span v-if="currentState === 'success-invite'">
          {{ $t('accept-invite.account-created' )}}
        </span>

        <div v-if="currentState === 'success-access'" class="success-wrapper">
          <div v-html="$t('accept-invite.account-access-created', { customerName: customer && customer.name })"></div>

          <SwitchCustomer/>
        </div>
      </SuccessAcceptInvite>

      <InvalidAcceptInvite v-if="currentState === 'invalid'" />

      <PasswordAcceptInvite v-if="currentState === 'initial'" v-on:success="stateUpdate = 'success-invite'" />
    </div>
  </div>
</template>

<script>
import SwitchCustomer from '@/components/svg/switch-customer.svg';

import SuccessAcceptInvite from '@/components/accept-invite/SuccessAcceptInvite';
import InvalidAcceptInvite from '@/components/accept-invite/InvalidAcceptInvite';
import PasswordAcceptInvite from '@/components/accept-invite/PasswordAcceptInvite';

export default {
  name: 'acceptInvite',
  components: {
    SwitchCustomer,

    SuccessAcceptInvite,
    InvalidAcceptInvite,
    PasswordAcceptInvite
  },
  props: {
    state: {
      type: String,
      default: 'initial'
    },
    customer: {
      type: Object
    }
  },
  data() {
    return { stateUpdate: '' };
  },
  computed: {
    currentState() {
      return this.stateUpdate || this.state || 'initial';
    }
  },
  methods: {
    onGoToApollo: function() {
      const params = new URLSearchParams();
      const customerId = this.customer && this.customer.customer_id;

      if (customerId) {
        params.set('customer_id', customerId);
      }

      location.replace(`${window.__config__.loginUrl}?${params.toString()}`);
    }
  }
};
</script>

<style scoped>
.success-wrapper {
  text-align: center;
}

svg {
  width: 42px;
  margin-top: 40px;
}

</style>
